import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { ToastProvider, ToastContainer } from '@/components/ui/Toast'
import { ResponsiveProvider } from '@/contexts/ResponsiveContext'
import { ScrollToTop } from '@/components/ui/Page/ScrollToTop'
import './utils/debugLots' // Add debug utilities
import { router } from './router'
import { captureSignupAttribution } from './utils/signupAttribution'

// Where this signup came from, read off the first sign-up / sign-in URL before the router
// rewrites it.
captureSignupAttribution();

// Set scroll restoration to manual so we can control it
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ResponsiveProvider>
      <ToastProvider>
        <RouterProvider router={router} />
        <ToastContainer />
        <Analytics />
      </ToastProvider>
    </ResponsiveProvider>
  </StrictMode>
)
